import { registerSettingsCard } from '../../components/SettingsCards';
import type { ModuleRoute } from '../types';
import { FeedbackReportPage } from './FeedbackReportPage';
import { HistoryPage } from './HistoryPage';
import { FeedbackCard, OnSiteReportCard } from './SettingsCards';
import { TimesheetPage } from './TimesheetPage';

registerSettingsCard('reports', OnSiteReportCard);
registerSettingsCard('feedback', FeedbackCard);

/** Pages of this area (history, timesheet, on-site report, feedback report). Owned by Phase 2 task W12; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/reports/history', element: <HistoryPage />, permission: 'history.view' },
  { path: '/reports/timesheet', element: <TimesheetPage />, permission: 'timesheets.view' },
  { path: '/reports/feedback', element: <FeedbackReportPage />, permission: 'feedback.view' },
];
